import $ from "jquery";
import { gsap, ScrollTrigger } from "gsap/all";
import Swiper from "swiper";
gsap.registerPlugin(ScrollTrigger);
const isDesktop = () => {
    return window.innerWidth >= 992;
};
class Bottle {
    constructor(canvas, images) {
        this.canvases = document.querySelectorAll(canvas);
        this.images = images;
        this.index = 0;
        this.drawing = false;
        this.loadedImages = [];
    }

    init() {
        this.loadAllImages();
        this.draw(0);
    }

    loadAllImages() {
        this.images.forEach((image, index) => {
            const img = new Image();
            img.src = image;
            this.loadedImages.push(img);
            if (!index) {
                img.onload = () => {
                    this.draw(0);
                };
            }
        });
    }

    draw(index) {
        if (this.loadedImages[index]) {
            this.canvases.forEach((canvas) => {
                const ctx = canvas.getContext("2d");
                ctx.clearRect(0, 0, 640, 640);
                ctx.drawImage(this.loadedImages[index], 0, 0, 640, 640);
            });
        }
    }

    drawImg(src) {
        this.canvases.forEach((canvas) => {
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, 640, 640);
            const img = new Image();
            img.src = src;
            img.onload = function () {
                ctx.drawImage(img, 0, 0, 640, 640);
            };
        });
    }

    percent(percent) {
        const index = Math.round((this.images.length * percent) / 100);
        if (index === this.index) return;
        this.draw(index);
        this.index = index;
    }

    next() {
        this.index = this.index === this.images.length - 1 ? 0 : this.index + 1;
        this.draw(this.index);
    }

    prev() {
        this.index = this.index === 0 ? this.images.length - 1 : this.index - 1;
        this.draw(this.index);
    }
}

class Sticky {
    constructor(el, height, offsetTop, progress, endEl) {
        this.el = $(el);
        this.parent = this.el.parent();
        this.height = height;
        this.progress = progress;
        this.offsetTop = offsetTop;
        this.endEl = endEl ? $(endEl) : null;
    }

    init() {
        if (!this.el.length) {
            return;
        }
        this.parent.css("height", this.height);
        this.el.css({ position: "sticky", top: this.offsetTop + "px" });
        document.addEventListener("scroll", () => this.handleScroll(), false);
        this.progress(this.getProgress(), this.el);
    }

    getProgress() {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        return ((scrollPosition - this.parent.offset().top + this.offsetTop) * 100) / this.parent.height();
    }

    handleScroll() {
        this.progress(this.getProgress(), this.el);
    }
}

window.acvAnimation = function (image) {
    $(document).ready(function () {
        const bottle = new Bottle(".bottle_canvas", image);
        bottle.init();

        const header = $("header:not(#shopify-section-header)");

        const sticky1 = new Sticky(
            ".acv-section__key .acv-section__inner",
            $(".acv-section__key .acv-section__inner").data("sticky-height"),
            header.height(),
            (progress, element) => {
                if (element.data("sections-count") === 2) {
                    if (progress > 0 && progress <= 30) {
                        element.addClass("first-section");
                        element.removeClass("second-section");
                    } else {
                        element.removeClass("first-section");
                    }

                    if (progress > 30) {
                        element.addClass("second-section");
                        element.removeClass("first-section");
                    }
                } else {
                    if (progress > 0) {
                        element.addClass("first-section");
                    } else {
                        element.removeClass("first-section");
                    }
                }
            },
            ".acv-section__accordion"
        );

        const sticky2 = new Sticky(
            ".acv-section__steps .acv-section__inner",
            "250vh",

            header.height(),
            (progress, element) => {
                const steps = element.find(".recipe__steps li");
                const images = element.find(".sticks__item");
                const title = element.find("h2");
                if (progress <= 0) {
                    title.css({
                        opacity: 0,
                        transform: `scale(2)`
                    });
                } else {
                    title.css({
                        opacity: 1,
                        transform: `scale(1)`
                    });
                }

                const stepDuration = 15;
                steps.each(function (index) {
                    const dir = index % 2 ? "right" : "left";
                    const val = -550 * (1 - (progress - index * stepDuration) / stepDuration);
                    $(this).css({
                        [dir]: val > 0 ? 0 : val
                    });
                    if (!(index % 2)) {
                        images.eq(index / 2).css({
                            opacity: (progress - index * stepDuration) / stepDuration
                        });
                    }
                });
            },
            "#shopify-section-acv-keyactives"
        );

        const sticky3 = new Sticky(
            ".acv-section__whatis .acv-section__inner",
            "250vh",

            header.height(),
            (progress, element) => {
                const steps = element.find(".acv-circle__points .acv-circle__points-item");
                const images = element.find(".acv-circle__sticks .sticks__item");
                const title = element.find("h2");

                if (progress <= 0) {
                    title.css({
                        opacity: 0,
                        transform: `scale(2)`
                    });
                } else {
                    title.css({
                        opacity: 1,
                        transform: `scale(1)`
                    });
                }

                const stepDuration = 15;
                steps.each(function (index) {
                    $(this).css({
                        opacity: (progress - index * stepDuration) / stepDuration
                    });
                    if (!(index % 2)) {
                        images.eq(index / 2).css({
                            opacity: (progress - index * stepDuration) / stepDuration
                        });
                    }
                });
            },
            "#shopify-section-acv-keyactives"
        );

        sticky1.init();
        if (isDesktop()) {
            sticky2.init();
            sticky3.init();
        }

        document.addEventListener(
            "scroll",
            function () {
                const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                if (isDesktop()) {
                    const firstSticky = $('.acv-section__steps, .acv-section__whatis')
                    const secondSticky = $('.acv-section__key')

                    const firstFlipStart = 0;
                    const firstFlipEnd = firstSticky.offset().top - header.height()

                    const secondFlipStart = firstSticky.offset().top + header.height() + firstSticky.height() - $(window).height()
                    const secondFlipEnd = secondSticky.offset().top - header.height()

                    const thirdFlipStart = secondSticky.offset().top + header.height() + secondSticky.height() - $(window).height()
                    const thirdFlipEnd = $("#end-animation").offset().top

                    let x;
                    if (scrollPosition <= firstFlipStart) {
                        x = 0
                    } else if (scrollPosition <= firstFlipEnd) {
                        x = 100 * scrollPosition / firstFlipEnd
                    } else if (scrollPosition > secondFlipStart && scrollPosition < secondFlipEnd) {
                        x = 100 * (scrollPosition - secondFlipStart) / (secondFlipEnd - secondFlipStart)
                    } else if (scrollPosition > thirdFlipStart && scrollPosition < thirdFlipEnd) {
                        x = 100 * (scrollPosition - thirdFlipStart) / (thirdFlipEnd - thirdFlipStart)
                    } else {
                        x = 0
                    }
                    // const bottleContainer = $(".bottle_canvas-container")
                    // bottleContainer.removeClass('bottle-steps')
                    // bottleContainer.removeClass('bottle-apple')

                    // if (scrollPosition > firstFlipEnd && scrollPosition < secondFlipStart) {
                    //     console.log(1)
                    //     bottleContainer.addClass('bottle-steps')
                    //     bottleContainer.removeClass('bottle-apple')
                    // } else if (scrollPosition > secondFlipEnd && scrollPosition < thirdFlipStart) {
                    //     console.log(2)
                    //     bottleContainer.removeClass('bottle-steps')
                    //     bottleContainer.addClass('bottle-apple')
                    // } else {
                    //     bottleContainer.removeClass('bottle-steps')
                    //     bottleContainer.removeClass('bottle-apple')
                    // }

                    bottle.percent(x);
                    // console.log(secondFlipStart, scrollPosition, secondFlipEnd);
                    // const animationEndY = $("#end-animation").offset().top;

                    // const animationLength = (animationEndY - animationStartY) / 2;
                    // let x = 0;
                    // if (scrollPosition > animationLength) {
                    //     x = ((scrollPosition - animationLength) * 100) / animationLength;
                    // } else {
                    //     x = (scrollPosition * 100) / animationLength;
                    // }

                    // bottle.percent(x);
                    setBottlePosition();
                    const button = $(".bottle_canvas-container .acv-pdp__btn");
                    const blur = $("#acv-blur");
                    const buttonRect = button[0].getBoundingClientRect();
                    const blurRect = blur[0].getBoundingClientRect();
                    if (blurRect.y - 400 < buttonRect.y && blurRect.y + blurRect.height > buttonRect.y) {
                        button.addClass("hidden-buy");
                    } else {
                        button.removeClass("hidden-buy");
                    }
                }
            },
            false
        );

        const setBottlePosition = () => {
            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            const startRight = 20;
            const endContainer = $("#end-animation");
            const OFFSET = 500;
            const endPosition = endContainer.offset().top - (window.innerHeight - endContainer.height()) * 0.5;
            if (scrollPosition < OFFSET) {
                $(".bottle_canvas-container").addClass("top-position");
            } else {
                $(".bottle_canvas-container").removeClass("top-position");
            }
            const top = 515
            if (!scrollPosition) {
                // START POSITION
                $(".bottle_canvas-container").css({
                    position: "fixed",
                    top: top + "px",
                    right: "20%",
                    left: "auto",
                    transition: "transform .3s",
                    transform: "translate(50%, -50%)"
                });
            } else if (scrollPosition < OFFSET) {
                // POSITION FROM START TO CENTER
                const newRight = startRight + ((50 - startRight) * scrollPosition) / OFFSET;
                $(".bottle_canvas-container").css({
                    position: "fixed",
                    top: top + "px",
                    right: newRight + "%",
                    left: "auto",
                    transform: "translate(50%, -50%)",
                    transition: "transform .3s"
                });
            } else if (endPosition > scrollPosition) {
                // CENTER POSITION
                $(".bottle_canvas-container").css({
                    position: "fixed",
                    top: top + "px",
                    right: "50%",
                    left: "auto",
                    transition: "transform .3s",
                    transform: "translate(50%, -50%)"
                });
            } else if (endPosition <= scrollPosition) {
                // END POSITION
                $(".bottle_canvas-container").css({
                    position: "absolute",
                    top: top + "px",
                    right: "50%",
                    left: "auto",
                    transform: "translate(50%, -50%)",
                    transition: "transform .3s"
                });
            }
        };
        if (isDesktop()) {
            setBottlePosition();
        }
        $(".acv-tabs__nav .btn--acv").on("click", function () {
            $('#acv-tabs .bottle-mob img').attr('src', $(this).data("img"))
            $('#acv-tabs .bottle-mob a').attr('href', $(this).data("btn-link"))
        });

        $("body").on("click", function () {
            $(".hoverd-text").removeClass("hover");
            if ($(this).hasClass("hoverd-text")) {
                $(this).addClass("hover");
            }
        });
    });
};

$(document).ready(function () {
    const acvHero = document.querySelector(".acv-hero");
    let observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.intersectionRatio > 0) {
                $(".acv-hero__left").addClass("show-left");
                $(".acv-pdp__inner").addClass("show-right");
                $(".acv-hero__title-badge").addClass("show-animation");
            } else {
                $(".acv-hero__left").removeClass("show-left");
                $(".acv-pdp__inner").removeClass("show-right");
                $(".acv-hero__title-badge").removeClass("show-animation");
            }
        },
        {
            root: null,
            rootMargin: "0px",
            threshold: 1
        }
    );
    if (acvHero) observer.observe(acvHero);

    // const acvHowMade = document.querySelector(".acv-section__steps .sticks__item ");
    // let observer2 = new IntersectionObserver(
    //     ([entry]) => {
    //         if (entry.intersectionRatio > 0) {
    //             const steps = $(".recipe__steps li");
    //             for (var i = 0; i < steps.length; i++) {
    //                 if (i % 2 === 0) {
    //                     steps[i].className += "show-left";
    //                 } else {
    //                     steps[i].className += "show-right";
    //                 }
    //             }
    //             $(".acv-section__steps .acv-section__inner h2").addClass("change-fs");
    //             $(".acv-section__steps .sticks .sticks__item-1").addClass("show-left");
    //             $(".acv-section__steps .sticks .sticks__item-2").addClass("show-right");
    //         }
    //     },
    //     {
    //         root: null,
    //         rootMargin: "0px",
    //         threshold: 0.1
    //     }
    // );
    // if (acvHowMade) observer2.observe(acvHowMade);

    const acvBlur = document.querySelector(".acv-section__blur");
    let observer6 = new IntersectionObserver(
        ([entry]) => {
            if (entry.intersectionRatio > 0) {
                $(".acv-section__blur .acv-section__inner").addClass("show-left-right");
                $(".acv-section__blur .sticks .sticks__item-1").addClass("show-left");
                $(".acv-section__blur .sticks .sticks__item-2").addClass("show-left");
                $(".acv-section__blur .sticks .sticks__item-3").addClass("show-right");
                $(".acv-section__blur .sticks .sticks__item-4").addClass("show-right");
            } else {
                $(".acv-section__blur .acv-section__inner").removeClass("show-left-right");
                $(".acv-section__blur .sticks .sticks__item-1").removeClass("show-left");
                $(".acv-section__blur .sticks .sticks__item-2").removeClass("show-left");
                $(".acv-section__blur .sticks .sticks__item-3").removeClass("show-right");
                $(".acv-section__blur .sticks .sticks__item-4").removeClass("show-right");
            }
        },
        {
            root: null,
            rootMargin: "0px",
            threshold: 0.2
        }
    );
    if (acvBlur) observer6.observe(acvBlur);
    var page = 1;
    var perPage = 5;
    function toggleReviews(show) {
        if (show) {
            $(".acv-section__reviews .tab-card").each(function (index) {
                if ($(this).index() < page * perPage) {
                    $(this).show();
                    $(this).css({ "transition-delay": 0 });
                    $(this).addClass("show-right");
                } else {
                    $(this).hide();
                }
            });
            // $(".acv-section__reviews .tab-card").addClass("show-right");
            $(".acv-circle__inner .acv-pdp").toggleClass("end-animation");

            if (page * perPage >= $(".acv-section__reviews .tab__column--right .reviews-box").eq(swiperAcv.realIndex).find('.tab-card').length) {
                $(".acv-section__reviews .review-form__loadmore").hide();
            }
        } else {
            $(".acv-section__reviews .tab-card").removeClass("show-right");
        }
    }

    function showHIdeLoadMore() {
        if (page * perPage >= $(".acv-section__reviews .tab__column--right .reviews-box").eq(bottleSwiper.realIndex).find('.tab-card').length) {
            $(".acv-section__reviews .review-form__loadmore").hide();
        } else {
            $(".review-form__loadmore").show();
        }
    }

    $(".review-form__loadmore").on("click", function (e) {
        e.preventDefault();
        page++;
        toggleReviews(true);
    });

    const acvReviews = document.querySelector(".acv-section__reviews");
    let observer7 = new IntersectionObserver(
        ([entry]) => {
            if (entry.intersectionRatio > 0.01) {
                toggleReviews(true);
            } else {
                toggleReviews(false);
            }
        },
        {
            root: null,
            rootMargin: "0px",
            threshold: 0.01
        }
    );
    if (acvReviews) observer7.observe(acvReviews);

    const stepsMob = document.querySelector(".acv-section__steps");
    let observer8 = new IntersectionObserver(
        ([entry]) => {
            if (entry.intersectionRatio > 0.5) {
                $(".acv-section__steps .recipe__steps").addClass("show-mob");
            } else {
                $(".acv-section__steps .recipe__steps").removeClass("show-mob");
            }
        },
        {
            root: null,
            rootMargin: "0px",
            threshold: 0.5
        }
    );
    if (stepsMob) observer8.observe(stepsMob);

    const whatisMob = document.querySelector(".acv-section__whatis");
    let observer9 = new IntersectionObserver(
        ([entry]) => {
            if (entry.intersectionRatio > 0.5) {
                $(".acv-circle-pdp__whatis").addClass("show-mob");
            } else {
                $(".acv-circle-pdp__whatis").removeClass("show-mob");
            }
        },
        {
            root: null,
            rootMargin: "0px",
            threshold: 0.5
        }
    );
    if (whatisMob) observer9.observe(whatisMob);

    // const keyMob = document.querySelector(".acv-key-first .acv-key--left");
    // let observer10 = new IntersectionObserver(
    //     ([entry]) => {
    //         if (entry.intersectionRatio > 0.5) {
    //             $(".acv-section__key .acv-section__inner").addClass("show-mob");
    //         } else {
    //             $(".acv-section__key .acv-section__inner").removeClass("show-mob");
    //         }
    //     },
    //     {
    //         root: null,
    //         rootMargin: "0px",
    //         threshold: 0.5
    //     }
    // );
    // if (keyMob) observer10.observe(keyMob);

    var bottleSwiper = new Swiper("#acv-pdp-carousel", {
        effect: "fade",
        fadeEffect: { crossFade: true },
        loop: true,
        speed: 800,
        slidesPerView: 1,

        navigation: {
            nextEl: ".swiper-button.swiper-button-next",
            prevEl: ".swiper-button.swiper-button-prev"
        }
    });
    var swiperAcv = new Swiper("#acv-pdp-slider", {
        effect: "slide",
        loop: true,
        speed: 800,
        slidesPerView: 1,

        navigation: {
            nextEl: ".swiper-button.swiper-button-next",
            prevEl: ".swiper-button.swiper-button-prev"
        }
    });

    bottleSwiper.on("slideChange", function (swiper) {
        $(".reviews-box").addClass("d-xs-none");
        $(".reviews-box").eq(this.realIndex).removeClass("d-xs-none");
        showHIdeLoadMore()
    });

    var container = document.querySelector(".acv-section__blur .sticks");
    var circles = document.querySelectorAll(".acv-section__blur .sticks__item");
    var sticker = document.querySelector(".acv-section__blur .sticks__item");
    var state = { distX: 0, distY: 0 };
    function onDown(e, circle) {
        e.preventDefault();
        state.distX = Math.abs(circle.offsetLeft - e.clientX);
        state.distY = Math.abs(circle.offsetTop - e.clientY);
        circle.classList.add("dragging");
    }
    function onUp(e, circle) {
        circle.classList.remove("dragging");
    }
    function onLeave(e, circle) {
        circle.classList.remove("dragging");
    }
    function onMove(e, circle) {
        if (circle.classList.contains("dragging")) {
            if (e.clientX - state.distX <= container.offsetWidth - sticker.offsetWidth && e.clientX - state.distX >= 0) {
                circle.style.left = `${e.clientX - state.distX}px`;
            }
            if (e.clientY - state.distY <= container.offsetHeight - sticker.offsetHeight && e.clientY - state.distY >= 0) {
                circle.style.top = `${e.clientY - state.distY}px`;
            }
        }
    }

    $(".acv-section__blur .sticks__item img, .acv-section__blur .sticks__item .hoverd-text").on("click", function () {
        $(".sticks__item").removeClass("hover");
        $(this).parent().toggleClass("hover");
    });

    circles.forEach((circle) => {
        circle.addEventListener("mousedown", (e) => onDown(e, circle));
        container.addEventListener("mousemove", (e) => onMove(e, circle));
        container.addEventListener("mouseup", (e) => onUp(e, circle));
        container.addEventListener("mouseleave", (e) => onLeave(e, circle));
    });
});
